import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-028be31f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "titulo-cadastro" }, " CADASTRAR LANCHE ")
], -1))
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "col-md-4 mx-auto py-5" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nomeLanche" }, "Nome Produto", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tipoDeCarne" }, "Tipo de carne", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Escolher", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Tradicional", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Picanha", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Gourmet", -1))
const _hoisted_10 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "quantidadeCarne" }, "Quantidade de carne", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nomeProduto" }, "Quantidade de ovo", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "tipoDeQueijo" }, "Tipo de queijo", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { selected: "" }, "Escolher", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Mussarela", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Cheedar", -1))
const _hoisted_17 = [
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "form-check" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckChecked"
}, " Bacon ", -1))
const _hoisted_20 = { class: "form-check" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckChecked"
}, " Presunto ", -1))
const _hoisted_22 = { class: "form-check" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckChecked"
}, " Alface ", -1))
const _hoisted_24 = { class: "form-check" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckChecked"
}, " Tomate ", -1))
const _hoisted_26 = { class: "form-check" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-check-label",
  for: "flexCheckChecked"
}, " Batata Palha ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-end" }, [
  /*#__PURE__*/_createElementVNode("button", { type: "submit" }, "Cadastrar")
], -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "text-center bg-dark py-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "assinatura" }, "Desenvolvido por Deivid Ferreira")
], -1))

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CadastrarProduto',
  setup(__props) {


const nomeProduto = ref('');
const tipoDeCarne = ref('');
const quantidadeDeCarne = ref(0);
const quantidadeDeOvo = ref(0);
const tipoDeQueijo = ref('');
const selecionarAlface = ref(false);
const selecionarBacon = ref(false);
const selecionarBatataPalha = ref(false);
const selecionarPresunto = ref(false);
const selecionarTomate = ref(false);

const handleSubmit = () => {
    console.log("Nome", nomeProduto.value),
    console.log("QtdCarne", quantidadeDeCarne.value),
    console.log("Tem Alface", selecionarAlface.value)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("form", {
      onSubmit: _withModifiers(handleSubmit, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "nomeLanche form-control",
          "aria-label": "First name",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((nomeProduto).value = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, nomeProduto.value]
        ]),
        _hoisted_5,
        _withDirectives(_createElementVNode("select", {
          class: "tipoDeCarne form-select form-select-md mb-3",
          "aria-label": ".form-select-md example",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tipoDeCarne).value = $event))
        }, _hoisted_10, 512), [
          [_vModelSelect, tipoDeCarne.value]
        ]),
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          type: "number",
          class: "quantidadeCarne form-control",
          "aria-label": "Last name",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((quantidadeDeCarne).value = $event))
        }, null, 512), [
          [_vModelText, quantidadeDeCarne.value]
        ]),
        _hoisted_12,
        _withDirectives(_createElementVNode("input", {
          type: "number",
          class: "quantidadeDeOvo form-control",
          "aria-label": "First name",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((quantidadeDeOvo).value = $event))
        }, null, 512), [
          [_vModelText, quantidadeDeOvo.value]
        ]),
        _hoisted_13,
        _withDirectives(_createElementVNode("select", {
          class: "tipoDeQueijo form-select form-select-md mb-3",
          "aria-label": ".form-select-md example",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tipoDeQueijo).value = $event))
        }, _hoisted_17, 512), [
          [_vModelSelect, tipoDeQueijo.value]
        ]),
        _createElementVNode("div", _hoisted_18, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            value: "",
            id: "flexCheckChecked",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selecionarBacon).value = $event))
          }, null, 512), [
            [_vModelCheckbox, selecionarBacon.value]
          ]),
          _hoisted_19
        ]),
        _createElementVNode("div", _hoisted_20, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            value: "",
            id: "flexCheckChecked",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selecionarPresunto).value = $event))
          }, null, 512), [
            [_vModelCheckbox, selecionarPresunto.value]
          ]),
          _hoisted_21
        ]),
        _createElementVNode("div", _hoisted_22, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            value: "",
            id: "flexCheckChecked",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((selecionarAlface).value = $event))
          }, null, 512), [
            [_vModelCheckbox, selecionarAlface.value]
          ]),
          _hoisted_23
        ]),
        _createElementVNode("div", _hoisted_24, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            value: "",
            id: "flexCheckChecked",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((selecionarTomate).value = $event))
          }, null, 512), [
            [_vModelCheckbox, selecionarTomate.value]
          ]),
          _hoisted_25
        ]),
        _createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            value: "",
            id: "flexCheckChecked",
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((selecionarBatataPalha).value = $event))
          }, null, 512), [
            [_vModelCheckbox, selecionarBatataPalha.value]
          ]),
          _hoisted_27
        ]),
        _hoisted_28
      ])
    ], 40, _hoisted_2),
    _hoisted_29
  ], 64))
}
}

})